
// Edit Window specifies how long a message can be edited for after it was sent.
export const TELEGRAM_MESSAGE_EDIT_WINDOW = 2; // in days
